export const Home = "/";
export const Login = "/login";
export const Sign_Up = "/signup";
export const Profile = "/p/:username";
export const Not_Found = "/not-found";
export const Dashboared = "/dashboared"
export const Add_Post = "/add-post";